import GenericDataGrid from "Admin/components/AdminComponents/GenericDataGrid";

function VendasList() {
  const fields = [
    { name: 'data', label: 'Data' },
    { name: 'total', label: 'Total', render: (item) => `R$ ${item.total.toFixed(2)}` },
    { name: 'modo_pagamento', label: 'Pagamento' },
    { name: 'cliente_id', label: 'Cliente' },
    { name: 'profissional_id', label: 'Profissional' }
  ];

  const actions = [
    { label: 'Detalhes', handler: (item) => console.log('Detalhes', item) },
    { label: 'Cancelar', handler: (item) => console.log('Cancelar', item) }
  ];

  return (
    <GenericDataGrid
      title="Histórico de Vendas"
      endpoint="/vendas"
      fields={fields}
      actions={actions}
    />
  );
}

export default VendasList;